import EntityHelper from '../helpers/entity';

export default class Role {
  constructor(data) {
    EntityHelper.validateData(data);
    const {
      id, name, translations,
    } = data;
    this.id = EntityHelper.setId(id);
    this.name = name;
    this.translations = EntityHelper.setTranslations(translations);
  }

  translated(locale) {
    if (!EntityHelper.hasTranslations(this, locale)) return this;
    return new Role({ ...this, name: this.translations[locale] });
  }

  equals(role) {
    return this.name === role.name;
  }
}
